module.exports = __webpack_public_path__ + "static/media/p208model5.cd6f8b09.jpg";